import styled from 'styled-components';
import { colors, device } from '../../styles/stylesheets';
import { Button } from '../../components/Button';
import polvo from '../../assets/img/orderDispatched.svg';
import polvoVariant from '../../assets/img/orderDispatchedVariant.svg';

export const Container = styled.div`
  display: flex;
  min-height: 95vh;
  flex: 1;
  flex-direction: column;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const FishContent = styled.div`
  background: url(${props => (props.taskResp ? polvoVariant : polvo)}) no-repeat;
  height: 22.5vh;
  width: 200px;
  min-height: 200px;
  margin-top: 5vh;
  margin-bottom: 10px;
`;

export const TitleContent = styled.h1`
  height: 100%;
  font-size: 24px;
  line-height: 23px;
  text-align: center;
  text-transform: uppercase;
  margin-bottom: 5vh;
`;

export const ContentOrder = styled.div`
  display: flex;
  justify-content: center;
  width: 76.25vw;
  font-size: 16px;
  line-height: 29px;
  text-align: center;
`;

export const ButtonViewTasks = styled(Button)`
  border: 1px solid ${colors.primary};
  height: 50px;
  width: 31.4vw;
  background-color: Transparent;

  font-size: 16px;
  line-height: 29px;
  margin-top: 6vh;
  text-align: center;
  min-width: 160px;

  color: ${colors.primary};

  @media ${device.untilTablet} {
    width: 80%;
    max-width: none;
  }
`;
